<div *ngIf="showAddForm" class="add-link-form">
    <div *ngIf="mode === 'VIEW'">
        <button
            class="btn-base bg-transparent color-blue border-none"
            type="button"
            [disabled]="working"
            (click)="addMode()"
        >
            <i class="fa fa-link"></i>&nbsp; Add Link
        </button>
    </div>
    <form
        *ngIf="mode !== 'VIEW'"
        [formGroup]="linkForm"
        (ngSubmit)="saveLink()"
    >
        <div class="horizontal-container fill vertical-align bottom-buffer">
            <label class="fill">Display Name </label>
            <input
                type="text"
                id="title"
                formControlName="title"
                class="form-control inline-form-input fcol-9"
                placeholder="Title"
            />
        </div>
        <div class="horizontal-container fill vertical-align bottom-buffer">
            <label class="fill">Link Address </label>
            <input
                type="text"
                id="url"
                formControlName="url"
                class="form-control inline-form-input fcol-9"
                placeholder="URL"
            />
        </div>
        <div class="horizontal-container fill justify-end">
            <button
                type="button"
                (click)="cancelEdit()"
                [disabled]="working"
                class="btn btn-inline right-buffer"
            >
                Cancel
            </button>
            <button
                class="btn btn-inline btn-link"
                type="submit"
                [disabled]="working || linkForm.invalid"
            >
                <i class="fa fa-plus"></i>
                {{ editingLink ? 'Update' : 'Add' }}
            </button>
        </div>
    </form>
</div>

<div class="link-list no-text-break">
    <div *ngFor="let link of links$ | async" class="link-item">
        <a class="text-dark-gray" (click)="onLinkClick(link)">
            <i class="fa-solid fa-up-right-from-square color-blue"></i>
            {{ link.title }}
        </a>
        <button
            *ngIf="allowDelete"
            type="button"
            (click)="deleteLink(link.id)"
            class="remove-button bg-transparent border-none"
        >
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
    <ngx-loading [show]="working"></ngx-loading>
</div>
